import { useSearchState } from "common/router/hooks";
import Navigate from "common/router/Navigate";
import { useIsHdEnabled } from "common/contexts/UIContext";

import TextButton from "client/common/components/buttons/TextButton";
import { INITIAL_CLIENT_DATA } from "client/common/utils";
import { Paths, urls } from "client/routes";

import CreateAccountEmailAuthForm from "./CreateAccountEmailAuthForm";
import AuthPage from "./AuthPage";
import { useClientQuery } from "../../hooks";
import LoadingPage from "../../../common/components/loading/LoadingPage";

import styles from "../../styles/CreateAccountPage.module.less";

const { has_completed_signup: hasCompletedSignup } = INITIAL_CLIENT_DATA;

const CreateAccountEmailPage = () => {
  const [search] = useSearchState<Paths["accounts"]["signup"]>({});
  const { data: client, isLoading } = useClientQuery();
  const isHdEnabled = useIsHdEnabled();

  if (hasCompletedSignup) {
    return <Navigate dest={search.next ? { to: search.next } : urls.accounts.detail()} />;
  }
  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <AuthPage
      title="Create an account"
      description={`Creating an account is fast and easy.${isHdEnabled ? " You'll be able to track your orders, manage Autoships, and request refills from your veterinarian!" : ""}`}
      flash={search.flash}
    >
      {/* we allow url params to override initial values if needed (mainly to persist data in case user toggles in
      between SMS and Email signup */}
      <div className={styles.container}>
        <CreateAccountEmailAuthForm
          initialPhone={search.phone ?? client?.primary_contact_number?.number}
          initialEmail={search.email ?? client?.primary_contact_email?.email}
          initialFirstName={search.first_name ?? client?.primary_client_user.first_name}
          initialLastName={search.last_name ?? client?.primary_client_user.last_name}
          next={search.next}
        />
        <div className={styles.help}>
          <TextButton dest={urls.accounts.login({ search: { ...search, phone: "" } })}>
            Login
          </TextButton>
          <span className={styles.space}>·</span>
          <TextButton dest={urls.accounts.resetPassword({ search: { ...search, phone: "" } })}>
            Reset Password
          </TextButton>
        </div>
      </div>
    </AuthPage>
  );
};

export default CreateAccountEmailPage;
